import { Col, Row, Input, Label } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
const InfoEditor = props => {
  const {
    annotation: {
      infoAnnotation
    },
    onChange
  } = props;
  const handleInfoChange = ({
    target
  }) => onChange('infoAnnotation/info', target.value);
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(Label, null, "Info")), /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(Input, {
    className: "t-info-comments",
    type: "textarea",
    value: infoAnnotation.info || '',
    onChange: handleInfoChange,
    style: {
      minHeight: '110px',
      height: '110px',
      resize: 'vertical'
    }
  })));
};
InfoEditor.propTypes = {
  annotation: PropTypes.shape({
    infoAnnotation: PropTypes.shape({
      info: PropTypes.string
    })
  }).isRequired,
  onChange: PropTypes.func.isRequired
};
export default InfoEditor;